import create, { SetState, StateCreator, StoreApi } from "zustand";

interface IDashboardStore {
  clearStore: () => void;

  responseOfApi: any;
  setResponse: (x: any) => void;
  selectedLob: any;
  setSelectedLob: (x: any) => void;
  selectedNavigation: any;
  setSelectedNavigation: (x: any) => void;
  reportList: any;
  setReportList: (x: any) => void;
  view: any;
  setView: (x: any) => void;
  searchedKeyWord: any;
  setSearchedKeyWord: (x: any) => void;
  selectedReport: any;
  setSelectedReport: (x: any) => void;
  accessToken: any;
  setaccessToken: (x: any) => void;
  embedURL: any;
  setEmbedURL: (x: any) => void;
}

let store: StateCreator<IDashboardStore, [], [], IDashboardStore> | StoreApi<IDashboardStore> = (set: SetState<IDashboardStore>) => ({
  responseOfApi: [],
  setResponse: (x) => {
    set(() => ({ responseOfApi: x }));
  },
  selectedLob: {},
  setSelectedLob: (x) => {
    set(() => ({ selectedLob: x }));
  },

  selectedNavigation: {},
  setSelectedNavigation: (x) => {
    set(() => ({ selectedNavigation: x }));
  },

  reportList: [],
  setReportList: (x) => {
    set(() => ({ reportList: x }));
  },

  view: "card",
  setView: (x) => {
    set(() => ({ view: x }));
  },
  searchedKeyWord: null,
  setSearchedKeyWord: (x) => {
    set(() => ({ searchedKeyWord: x }));
  },

  selectedReport: null,
  setSelectedReport: (x) => {
    set(() => ({ selectedReport: x }));
  },
  embedURL: "",
  setEmbedURL: (x) => {
    set(() => ({ embedURL: x }));
  },

  accessToken: "",
  setaccessToken: (x) => {
    set(() => ({ accessToken: x }));
  },
  clearStore: () => {
    set(() => ({ responseOfApi: [] }));
    set(() => ({ selectedLob: {} }));
    set(() => ({ selectedNavigation: {} }));
    set(() => ({ reportList: [] }));
    set(() => ({ view: "card" }));
    set(() => ({ searchedKeyWord: null }));
    set(() => ({ selectedReport: null }));
    set(() => ({ embedURL: "" }));
    set(() => ({ accessToken: "" }));
  },
});

export const useDashboardStore = create(store);
